import { useCommonContext } from "@/utils/context/common";
import { getCookie } from "@/utils/platform";


type pageViewParams = {
  tab: number;
};

type discoveryCardClickParams = {
  item: any;
  btn_name: string;
  index: number;
  tab_name?: string;
};
export const useTrack = () => {
  const { track } = useCommonContext();
  //pageview埋点
  const trackPageView = (params: pageViewParams) => {
    try {
      // console.log("params", params);
      const { tab } = params;
      const page_name =
        tab === 1
          ? "实拍专区_列表"
          : "实拍专区_视频";
      if (track.track) {
        track.track("$pageview", {
          page_name: page_name,
          previous_page_name: "",
          tab_name: "推荐",
          domain:  "实拍专区",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };


  //种草专区卡片点击
  const trackDiscoveryCardClick = (params: discoveryCardClickParams) => {
    try {
      const { item, btn_name, index, tab_name, } = params;
      // console.log("trackDiscoveryCardClick", params);
      if (item) {
        if (track.track) {
          track.track("resource_click", {
            page_name:  "实拍专区_列表" ,
            previous_page_name: "",
            domain: "实拍专区" ,
            tab_name: tab_name,
            resource_type: "种草图文组件",
            resource_name: item?.name,
            resource_rank: index,
            material_id: item?.materialNo,
            search_request_id: (getCookie("mstoken") || "") + Date.now() + "", //搜索请求ID
            resource_content: "资源位跳转内容类型：素材",
            btn_name: btn_name,
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };


  return {
    trackPageView,
    trackDiscoveryCardClick,
  };
};
